
import { Component } from "react";
import React from "react";
import "./Cometblackstorm.css";
import { Link } from "react-router-dom";
import Navbar from "../../Home/Components/Nav";
import Footer from "../../Home/Components/Footer";
import "bootstrap/dist/css/bootstrap.min.css";
import Contactus from "../../contact/Container/Contactformcon";
import HeroPriceSection from "../../MgComet/Components/HeroPriceSection";
import ReusableImageSections from "../../MgComet/CometImageSections";

const cometImages = [
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/COMETBLASTORM%2Fmg-bn-dsc-091.webp?alt=media&token=5e75852a-5f35-4d1f-87de-f045f22aad75",
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/COMETBLASTORM%2Fmg-bn-dsc-092.webp?alt=media&token=9994086b-eff2-4208-b247-cda7f353f1b8",
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/COMETBLASTORM%2Fmg-bn-dsc-093.webp?alt=media&token=9c0e638e-abc2-47e5-8d62-e7b46a939147",
];
class Cometblackstorm extends Component {
  render() {
    return (
      <div id="container">
        <Navbar />

        {/* HERO SECTION (Reusable) */}
        <HeroPriceSection
          basePrice="BASE PRICE STARTS @ ₹7.63* LAKH + ₹3.1/KM*"
          mainPrice="PRICE STARTS @ ₹9.99* LAKH"
          buttonText="Download Brochure"
          desktopBg="https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/COMETBLASTORM%2Fcm-bn-dsc-0433.jpeg?alt=media"
          mobileBg="https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/COMETBLASTORM%2Fcm-bn-dsc-0433-portrait.webp?alt=media"
        />

        {/* Breadcrumb */}
        <div style={{ height: "40px", marginTop: "8px", marginLeft: "50px" }}>
          <Link to="/" style={{ textDecoration: "none", color: "grey" }}>
            <b>Home</b>
          </Link>
          <Link
            to="/Cometevblackstorm"
            style={{ textDecoration: "none", color: "grey" }}
          >
            &nbsp;&nbsp;MG Hector Snowstorm
          </Link>
        </div>

        {/* Image Sections */}
        <ReusableImageSections images={cometImages} />

        <Contactus someValue="Commit" />
        <Footer />
      </div>
    );
  }
}

export default Cometblackstorm;
